import React, { useState } from 'react';
import '../../styles/admin/ReportTable.css';

const ReportTable = ({ data, type, title }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);

  const renderSalesTable = () => (
    <table className="report-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Invoice ID</th>
          <th>Items</th>
          <th>Total Amount</th>
        </tr>
      </thead>
      <tbody>
        {currentData.length === 0 ? (
          <tr>
            <td colSpan="4" className="no-data">
              <i className="fas fa-inbox"></i>
              <p>No sales transactions found</p>
            </td>
          </tr>
        ) : (
          currentData.map((invoice, index) => (
            <tr key={invoice._id || index}>
              <td>{new Date(invoice.date).toLocaleDateString()}</td>
              <td className="invoice-id">{invoice._id?.substring(0, 8)}...</td>
              <td>{invoice.items?.length || 0}</td>
              <td className="amount">LKR {invoice.totalAmount.toFixed(2)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );

  const renderProductsTable = () => (
    <table className="report-table">
      <thead>
        <tr>
          <th>Product Name</th>
          <th>Quantity Sold</th>
          <th>Total Revenue</th>
          <th>Avg Price</th>
        </tr>
      </thead>
      <tbody>
        {currentData.length === 0 ? (
          <tr>
            <td colSpan="4" className="no-data">
              <i className="fas fa-inbox"></i>
              <p>No product data found</p>
            </td>
          </tr>
        ) : (
          currentData.map((product, index) => (
            <tr key={index}>
              <td className="product-name">{product.name}</td>
              <td className="quantity">{product.quantity}</td>
              <td className="amount">LKR {product.revenue.toFixed(2)}</td>
              <td className="amount">LKR {(product.revenue / product.quantity).toFixed(2)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );

  const renderInventoryTable = () => (
    <table className="report-table">
      <thead>
        <tr>
          <th>Barcode</th>
          <th>Product Name</th>
          <th>Type</th>
          <th>Stock Quantity</th>
          <th>Status</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {currentData.length === 0 ? (
          <tr>
            <td colSpan="6" className="no-data">
              <i className="fas fa-inbox"></i>
              <p>No inventory data found</p>
            </td>
          </tr>
        ) : (
          currentData.map((product, index) => {
            const getStatus = (qty) => {
              if (qty === 0) return { text: 'Out', class: 'out' };
              if (qty < 10) return { text: 'Low', class: 'low' };
              return { text: 'Good', class: 'good' };
            };
            const status = getStatus(product.stockQty);
            const value = product.type === 'fixed' 
              ? product.price * product.stockQty 
              : product.pricePerKg * product.stockQty;

            return (
              <tr key={product._id || index}>
                <td className="barcode">{product.barcode}</td>
                <td className="product-name">{product.name}</td>
                <td>
                  <span className={`type-badge ${product.type}`}>
                    {product.type === 'fixed' ? 'Fixed' : 'Weight'}
                  </span>
                </td>
                <td className="quantity">{product.stockQty}</td>
                <td>
                  <span className={`status-badge ${status.class}`}>
                    {status.text}
                  </span>
                </td>
                <td className="amount">LKR {value.toFixed(2)}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );

  const renderTable = () => {
    switch (type) {
      case 'sales':
        return renderSalesTable();
      case 'products':
        return renderProductsTable();
      case 'inventory':
        return renderInventoryTable();
      default:
        return null;
    }
  };

  return (
    <div className="report-table-container">
      <div className="table-title">
        <h2>
          <i className={`fas ${
            type === 'sales' ? 'fa-file-invoice-dollar' :
            type === 'products' ? 'fa-box-open' :
            'fa-warehouse'
          }`}></i>
          {title}
        </h2>
        <span className="record-count">{data.length} records</span>
      </div>

      <div className="table-scroll">
        {renderTable()}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            className="page-btn"
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
          >
            <i className="fas fa-angle-double-left"></i>
          </button>
          <button
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            <i className="fas fa-angle-left"></i>
          </button>
          
          <span className="page-info">
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            <i className="fas fa-angle-right"></i>
          </button>
          <button
            className="page-btn"
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
          >
            <i className="fas fa-angle-double-right"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default ReportTable;